<ng-content></ng-content>

<hfc-button *ngIf="closeButton" icon="close" class="close-button" routerLink="/dashboard"></hfc-button>
